/**
 * Die Prüfgrundlagen einer Prüfung.
 *
 * Sie standen bisher nur als Vorgabewerte im Modell — auf der
 * Bescheinigung erschienen Kreuze, die niemand setzen konnte. Das fiel
 * nicht auf, solange die Vorgabe für einen Gemeindespielplatz stimmte.
 * Mit DIN EN 16630 stimmt sie nicht mehr: Fitnessgeräte stehen auf
 * manchen Flächen und auf den meisten nicht.
 *
 * Der Block ist eingeklappt. Im Regelfall passt die Vorgabe, und was
 * meistens passt, soll nicht jedes Mal Platz kosten — die Zusammenfassung
 * in der Kopfzeile genügt zum Prüfen.
 */

import { useState } from 'react'
import { PRUEFGRUNDLAGEN, type Pruefung } from '../api/typen'
import { usePruefungAendern } from '../api/abfragen'
import { Fehlerhinweis } from '../bausteine/Hinweise'

export function Grundlagen({
  pruefung,
  nurLesen,
}: {
  pruefung: Pruefung
  nurLesen: boolean
}) {
  const [offen, setzeOffen] = useState(false)
  const aendern = usePruefungAendern()

  const gesetzte = PRUEFGRUNDLAGEN.filter((g) => pruefung[g.feld])

  return (
    <section className="karte">
      <div className="flex flex-wrap items-start gap-3">
        <div className="min-w-0 flex-1">
          <h2 className="font-bold">Prüfgrundlagen</h2>
          <p className="text-base text-slate-700">
            {gesetzte.length === 0 ? (
              <span className="font-semibold text-stufe-2">
                Keine angekreuzt — die Bescheinigung nennt dann keine Norm.
              </span>
            ) : (
              gesetzte.map((g) => g.norm).join(' · ')
            )}
          </p>
        </div>
        {!nurLesen && (
          <button
            type="button"
            className="knopf-still px-3"
            onClick={() => setzeOffen((o) => !o)}
          >
            {offen ? 'Schließen' : 'Ändern'}
          </button>
        )}
      </div>

      {offen && (
        <div className="mt-3 space-y-2 border-t-2 border-slate-200 pt-3">
          <p className="text-base text-slate-700">
            Angekreuzt wird, wonach tatsächlich geprüft wurde. Was hier steht,
            erscheint unverändert auf der Prüfbescheinigung.
          </p>

          {PRUEFGRUNDLAGEN.map((g) => (
            <label
              key={g.feld}
              className="flex cursor-pointer items-start gap-3 rounded-feld border-2 border-slate-200 p-2 font-normal"
            >
              <input
                type="checkbox"
                checked={Boolean(pruefung[g.feld])}
                disabled={aendern.isPending}
                onChange={(e) =>
                  aendern.mutate({ id: pruefung.id, [g.feld]: e.target.checked })
                }
                className="mt-1 h-6 w-6 shrink-0"
                style={{ minHeight: 'auto' }}
              />
              <span>
                <span className="font-semibold">{g.norm}</span>
                <span className="block text-base text-slate-600">{g.wofuer}</span>
              </span>
            </label>
          ))}

          <Fehlerhinweis fehler={aendern.error} />
        </div>
      )}
    </section>
  )
}
